import { render, staticRenderFns } from "./goal_list.vue?vue&type=template&id=37f68ed3&scoped=true&"
import script from "./goal_list.vue?vue&type=script&lang=js&"
export * from "./goal_list.vue?vue&type=script&lang=js&"
import style0 from "./goal_list.vue?vue&type=style&index=0&id=37f68ed3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f68ed3",
  null
  
)

export default component.exports